import { Navigate, Outlet } from 'react-router-dom';
import { isComunidadEnabled } from '../utils/comunidadAccess';

/**
 * Interruptor de la ruta /comunidad (ver `isComunidadEnabled`). Hoy Comunidad está abierta a
 * todas las psicólogas, así que nunca redirige; si se vuelve a cerrar, quien escriba
 * /comunidad a mano sin acceso va a /home — no solo se le oculta el tab de la nav.
 */
export const ComunidadGuard = () => {
  if (!isComunidadEnabled()) {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
};
